import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI } from '../../Varios';

export const function_ABM_IMP_PuntosFiscales_Listar = async () => {
    const NombreFuncion = "function_ABM_IMP_PuntosFiscales_Listar"

    try {        
        const resulData = await llamadaAPI_GET("ABM_IMP_PuntosFiscales/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));        
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_IMP_PuntosFiscales_Leer = async (CodigoPuntoFiscal, IdTipoMovimiento, IdTipo) => {
    const NombreFuncion = "function_ABM_IMP_PuntosFiscales_Leer"

    try {        
        const resulData = await llamadaAPI_GET("ABM_IMP_PuntosFiscales/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoPuntoFiscal) + "/" + IdTipoMovimiento + "/" + IdTipo);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_IMP_PuntosFiscales_LeerPorTerminal = async (Terminal, IdTipoMovimiento, IdTipo) => {
    const NombreFuncion = "function_ABM_IMP_PuntosFiscales_LeerPorTerminal"

    try {        
        const resulData = await llamadaAPI_GET("ABM_IMP_PuntosFiscales/LeerPorTerminal/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" + Terminal + "/" + IdTipoMovimiento + "/" + IdTipo);        
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_IMP_PuntosFiscales_ObtenerProximoNumeroPorCodigoPuntoFiscal = async (CodigoPuntoFiscal, IdTipoMovimiento, IdTipo) => {
    const NombreFuncion = "function_ABM_IMP_PuntosFiscales_ObtenerProximoNumeroPorCodigoPuntoFiscal"

    try {        
        const resulData = await llamadaAPI_GET("ABM_IMP_PuntosFiscales/ObtenerProximoNumeroPorCodigoPuntoFiscal/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" + 
            CodigoPuntoFiscal + "/" + 
            IdTipoMovimiento + "/" + 
            IdTipo);        
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_IMP_PuntosFiscales_Insertar = async (Objeto) => {
    const NombreFuncion = "function_ABM_IMP_PuntosFiscales_Insertar";

    try {
        const objetoResult = await llamadaAPI_POST("ABM_IMP_PuntosFiscales/InsertarCompleto", Objeto);
        return objetoResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_IMP_PuntosFiscales_Modificar = async (Objeto) => {
    const NombreFuncion = "function_ABM_IMP_PuntosFiscales_Modificar";

    try {
        await llamadaAPI_PUT("ABM_IMP_PuntosFiscales/ModificarCompleto", Objeto);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_IMP_PuntosFiscales_Generar_JSON = async (CodigoPuntoFiscal, IdTipoMovimiento, IdTipo, UltimoNumero,
    IdEstado, EsElectronico, PathCertificado, CUIT, Terminal, Fiscal_RazonSocial, Fiscal_Domicilio, Fiscal_Telefono, Fiscal_Email,
    Fiscal_Web, Fiscal_CondicionIVA, Fiscal_CUIT, Fiscal_IIBB, Fiscal_TipoIIBB, Fiscal_InicioActividadAFIP, Fiscal_InicioActividadIIBB,
    CodigoListaPrecios,  CodigoUbicacionPredeterminada, ImpresoraFiscalTipo, ImpresoraFiscalPuerto, ImpresoraComandera1,
    ImpresoraComandera2, ImpresoraComandera3, ImpresoraComanderaTicket, ImpresoraStandard, ImpresoraFiscalIP, ImpresoraComanderaRetiro,
    ColumnasImpresoraComanderaTicket, ImpresoraComandera4, CAIImprime, CAI, CAIComprobanteDesde, CAIComprobanteHasta, CAIFechaVencimiento) => {
    const NombreFuncion = "function_ABM_IMP_PuntosFiscales_Generar_JSON";

    try {
        
        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            CodigoPuntoFiscal: CodigoPuntoFiscal,
            IdTipoMovimiento: IdTipoMovimiento,
            IdTipo: IdTipo,
            UltimoNumero: UltimoNumero,
            IdEstado: IdEstado,
            EsElectronico: EsElectronico,
            PathCertificado: PathCertificado,
            CUIT: CUIT,
            Terminal: Terminal,
            Fiscal_RazonSocial: Fiscal_RazonSocial,
            Fiscal_Domicilio: Fiscal_Domicilio,
            Fiscal_Telefono: Fiscal_Telefono,
            Fiscal_Email: Fiscal_Email,
            Fiscal_Web: Fiscal_Web,
            Fiscal_CondicionIVA: Fiscal_CondicionIVA,
            Fiscal_CUIT: Fiscal_CUIT,
            Fiscal_IIBB: Fiscal_IIBB,
            Fiscal_TipoIIBB: Fiscal_TipoIIBB,
            Fiscal_InicioActividadAFIP: Fiscal_InicioActividadAFIP,
            Fiscal_InicioActividadIIBB: Fiscal_InicioActividadIIBB,
            CodigoListaPrecios: CodigoListaPrecios,
            CodigoUbicacionPredeterminada: CodigoUbicacionPredeterminada,
            ImpresoraFiscalTipo: ImpresoraFiscalTipo,
            ImpresoraFiscalPuerto: ImpresoraFiscalPuerto,
            ImpresoraComandera1: ImpresoraComandera1,
            ImpresoraComandera2: ImpresoraComandera2,
            ImpresoraComandera3: ImpresoraComandera3,
            ImpresoraComanderaTicket: ImpresoraComanderaTicket,
            ImpresoraStandard: ImpresoraStandard,
            ImpresoraFiscalIP: ImpresoraFiscalIP,
            ImpresoraComanderaRetiro: ImpresoraComanderaRetiro,
            ColumnasImpresoraComanderaTicket: ColumnasImpresoraComanderaTicket,
            ImpresoraComandera4: ImpresoraComandera4,
            CAIImprime: CAIImprime,
            CAI: CAI,
            CAIComprobanteDesde: CAIComprobanteDesde,
            CAIComprobanteHasta: CAIComprobanteHasta,
            CAIFechaVencimiento: CAIFechaVencimiento
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_IMP_PuntosFiscales_ModificarLogo = async (CodigoPuntoFiscal,
    IdTipoMovimiento, IdTipo, Logo) => {
    const NombreFuncion = "function_ABM_IMP_PuntosFiscales_ModificarLogo";

    try {
        
        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            CodigoPuntoFiscal: CodigoPuntoFiscal,
            IdTipoMovimiento: IdTipoMovimiento, 
            IdTipo: IdTipo, 
            Logo: Logo
        };

        await llamadaAPI_PUT("ABM_IMP_PuntosFiscales/ModificarLogo", JSON);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_IMP_PuntosFiscales_UltimoDocVentaARCA = async (CodigoPuntoFiscal, IdTipo) => {
    const NombreFuncion = "function_ABM_IMP_PuntosFiscales_UltimoDocVentaARCA"

    try {
        const resulData = await llamadaAPI_GET("ARCA/UltimoNumero/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            CodigoPuntoFiscal + "/" +
            IdTipo);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};
/*
router.get("/API/ABM_IMP_PuntosFiscales/Listar/:CodigoCompania/:CodigoEmpresa/:CodigoPlanta/:Where?", ABM_IMP_PuntosFiscales_Listar)
router.get("/API/ABM_IMP_PuntosFiscales/Leer/:CodigoCompania/:CodigoEmpresa/:CodigoPlanta/:CodigoPuntoFiscal/:IdTipoMovimiento/:IdTipo", ABM_IMP_PuntosFiscales_Leer)
router.put("/API/ABM_IMP_PuntosFiscales/Eliminar/:CodigoCompania/:CodigoPuntoFiscal", ABM_IMP_PuntosFiscales_Eliminar)
*/